import { render, staticRenderFns } from "./DyoProducts.vue?vue&type=template&id=a4217e3e&"
import script from "./DyoProducts.vue?vue&type=script&lang=js&"
export * from "./DyoProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports